import React, { useState } from 'react';
import { HomeServiceCardDetails } from '../molecules/HomeServiceCardDetails';
import { Carousel, CarouselItem, CarouselControl } from 'reactstrap';
import { Trans } from '@lingui/react';
import { ServiceCard } from '../atoms';
import './HomeServiceCardMobile.css';

export const HomeServiceCardMobile: React.FunctionComponent = () => {
  const [animating, setAnimating] = useState(false);

  const [activeCardKey, setActiveCardKey] = useState(0);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeCardKey === cardStyle.length - 1 ? 0 : activeCardKey + 1;
    setActiveCardKey(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeCardKey === cardStyle.length - 1 ? 0 : activeCardKey - 1;
    setActiveCardKey(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveCardKey(newIndex);
  };

  const cardStyle = [
    {
      color: 'info',
      extraClass: 'service-card fixed-height',
      icon: 'ni-paper-diploma',
    },
    {
      color: 'danger',
      extraClass: 'info-raised service-card fixed-height',
      icon: 'ni-paper-diploma',
    },
    {
      color: 'default',
      extraClass: 'service-card fixed-height',
      icon: 'ni-hat-3',
    },
    {
      color: 'primary',
      extraClass: 'service-card service-card fixed-height',
      icon: 'ni-headphones',
    },
    {
      color: 'warning',
      extraClass: 'info-raised service-card fixed-height',
      icon: 'ni-single-copy-04',
    },
    {
      color: 'success',
      extraClass: 'service-card fixed-height',
      icon: 'ni-single-02',
    },
  ];

  const items = cardStyle.map((styleValue, i) => {
    return (
      <CarouselItem key={i + 1}>
        <div className="d-flex flex-column align-items-center">
          <ServiceCard
            className="fixed-height"
            id={i + 1}
            color={styleValue.color}
            extraClass={styleValue.extraClass}
            icon={styleValue.icon}
            title={<Trans id={`card_${i + 1}_title`} />}
            description={<Trans id={`card_${i + 1}_description`} />}
            selected={activeCardKey}
          />
          <div className="w-100 px-3 mt-2 pb-5">
            <HomeServiceCardDetails
              activeCardKey={i + 1}
              activeCardContent={<Trans id={`card_${i + 1}_content`} />}
              activeCardTitle={''}
            />
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <Carousel
      className="carousel-card-m"
      dark={true}
      slide={false}
      activeIndex={activeCardKey}
      next={next}
      previous={previous}
    >
      {/* <CarouselIndicators
        items={cardStyle}
        activeIndex={activeCardKey}
        onClickHandler={goToIndex}
      /> */}
      {items}
      <CarouselControl
        direction="prev"
        directionText="Previous"
        onClickHandler={previous}
      />
      <CarouselControl
        direction="next"
        directionText="Next"
        onClickHandler={next}
      />
    </Carousel>
  );
};
